import { Icon, IconProps } from '@chakra-ui/react'

export function BtcLightningIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 29 36" {...props}>
      <path
        d="M1.76753 19.6486L19.953 2.02146C20.7564 1.43781 21.5845 1.92402 21.1293 2.87014L15.7283 15.2412L26.6389 14.5895C26.6389 14.5895 28.3723 14.486 26.7239 16.0139L8.85044 33.7245C7.5917 34.9228 6.63753 34.3672 7.45194 32.5827L12.6672 20.5292L1.85868 21.1748C1.85868 21.1748 0.125232 21.2783 1.76753 19.6486Z"
        stroke="currentColor"
        strokeOpacity="0.64"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />

    </Icon>
  )
}
